import React from 'react';

class NoteBlock extends React.Component {

	render() {
		const text = this.props.note || 'This is a Note.';

		return (
			<div className="NoteBlock">
				{text}
			</div>
		);
	}

}

export default NoteBlock;
